import { css } from '@emotion/css';
import { actImageUrl, commonGenresStyle } from 'Shared/frontend/eventPosters/MusicPoster';
import { combinedGenres } from 'Shared/common/Macros';
import { nameStyle, maxTextLines} from 'Shared/frontend/Poster';
import { Show } from 'solid-js';
import { poster } from 'Shared/frontend/SettingsProvider';


export function FourActs(P)
{
	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'fourActs');

	const posterStyle = () => css(theme().contents,{
		width: '100%',
	});

	const imageStyle = () => css(theme().img);

	const imageWrapStyle = () => css(theme().imageWrap,{
		display: 'block',
		width: 135,
		img: {
			width: '100%',
			display: 'block',
		}
	});

	const artist1ImageStyle = () => css(imageWrapStyle(),{
		zIndex: '1',
		marginLeft: 10,
		position: 'relative',
	});

	const artist2ImageStyle = () => css(imageWrapStyle(),{
		float: 'right',
		marginRight: 10,
		marginTop: '-43px',
	});

	const artist3ImageStyle = () => css(imageWrapStyle(),{
		float: 'left',
		marginLeft: 10,
		marginTop: '-43px',
		zIndex: '1',
		position: 'relative',
	});

	const artist4ImageStyle = () => css(imageWrapStyle(),{
		float: 'right',
		marginTop: '-43px',
		marginRight: 10,
		zIndex: '1',
		position: 'relative',
	});

	const detailsStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		paddingTop: '0.7em',
		height: '112px', // pushes genres to bottom of poster
	});

	const eventNameArtistNameStyle = () => css({
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'center',
	});

	const eventNameStyle = () => css(nameStyle(), {
		width: '100%',
		marginBottom: '0.5em',
		...maxTextLines(2),
		fontSize: s().nameFontSize ?? theme().name.fontSize
	});

	const artistNameStyle = () => css(theme().artistNames, {
		fontSize: s().artistNamesFontSize ?? theme().artistNames.fontSize
	});

	const genresStyle = () => css(commonGenresStyle(),theme().genres, {
		whiteSpace: 'normal', // we're grouping data so needs to be overridden from commonGenreStyle
	});


	const hide = () => s()?.hide ?? [];

	return (
		<div class={posterStyle()}>
			<div class={artist1ImageStyle()}>
				<img class={imageStyle()} src={actImageUrl(P.lineup[0].image)} height={90} />
			</div>
			<div class={artist2ImageStyle()}>
				<img class={imageStyle()} src={actImageUrl(P.lineup[1].image)} height={90} />
			</div>
			<div class={artist3ImageStyle()}>
				<img class={imageStyle()} src={actImageUrl(P.lineup[2].image)} height={90} />
			</div>
			<div class={artist4ImageStyle()}>
				<img class={imageStyle()} src={actImageUrl(P.lineup[3].image)} height={90} />
			</div>

			<div style='clear:both' />

			<div class={detailsStyle()}>
				<div class={eventNameArtistNameStyle()}>
					<div class={eventNameStyle()}>
						<Show when={!hide().includes('name') && P.name}>
							{ P.name }
						</Show>
					</div>

					<Show when={!hide().includes('artistName')}>
						<div class={artistNameStyle()}>
							{P.lineup[0].name}{', '}
							{P.lineup[1].name}{', '}
							{P.lineup[2].name}{' & '}
							{P.lineup[3].name}
						</div>
					</Show>
				</div>
				<div class={genresStyle()}>
					<Show when={!hide().includes('artistGenres')}>
						{ combinedGenres(P.lineup) }
					</Show>
				</div>
			</div>
		</div>
	);
}

